module.exports = "<div class=\"dons\">\r\n    <div class=\"titre\">\r\n        <h2>Votre soutien</h2>\r\n    </div>\r\n    <div class=\"texte\">\r\n        <p>\r\n            Votre générosité permet de soutenir les actions d'Abaim. Donnez sur le formulaire\r\n            <u><b><a href=\"https://www.helloasso.com/associations/association-le-sourire/formulaires/2\" target=\"_newtab\">HelloAsso</a></b></u> !\r\n        </p>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dons/dons.template.html
// module id = 25
// module chunks = 0